import React from 'react'
import { styled } from 'src/ui/theme'
import { Header, Body } from 'src/ui/typography'
import { Button } from 'src/ui/molecules'
import { Image } from 'src/ui/atoms'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 16px;
`

const Layout = styled.div`
  display: block;
  padding: 24px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.gray.bg};
  margin: 16px 0;
`

const Title = styled(Header)`
  color: ${({ theme }) => theme.colors.black.primary};
  margin: 16px 0;
`

const Subtitle = styled(Body)`
  color: ${({ theme }) => theme.colors.black.bg};
  margin-bottom: 24px;
`

const StyledButton = styled(Button)`
  max-width: 220px;
  margin-bottom: 16px;
`

type Props = {
  images: TImages
  onScrollToForm: () => void
  onScrollToReward: () => void
}

export const Intro: React.FC<Props> = ({
  images,
  onScrollToForm,
  onScrollToReward,
}) => {
  return (
    <Wrapper>
      <Layout>
        <Image
          fluid={images['referral-intro']}
          objectFit="contain"
          height={137}
        />
      </Layout>
      <Title size="h4">
        Приведи друга в KODE — получи денежное вознаграждение!
      </Title>
      <Subtitle>
        Мы заинтересованы в развитии компании и всегда рады новым талантливым
        специалистам в нашей команде. За ценную рекомендацию мы готовы
        отблагодарить бонусом{' '}
        <a href="#" onClick={onScrollToReward}>
          от 5 до 100 тысяч рублей.
        </a>
      </Subtitle>
      <StyledButton onClick={onScrollToForm}>Рекомендовать друга</StyledButton>
    </Wrapper>
  )
}
